import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import './ButtonBar.scss';

export default class ButtonBar extends PureComponent {
  render() {
    const {children} = this.props;

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <div {...this.props}>{children}</div>;
  }
}

ButtonBar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
};

ButtonBar.defaultProps = {
  className: 'button-bar',
  // eslint-disable-next-line react/jsx-no-useless-fragment
  children: <></>,
};
